import {
  EvidenceControl,
  EvidenceGroup,
} from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import React, { useEffect, useMemo } from 'react'
import { useCurrentAudit } from 'src/components/async/model/audit'
import { TableListLoader } from 'src/components/Reusable/ContentLoaders/TableListLoader'
import { Grid } from 'src/components/Reusable/Grid'
import { ControlsIndexGridHeader } from 'src/pages/Controls/ControlsIndexPage/ControlsIndexGrid/ControlsIndexGridHeader'
import { ControlsListItem } from 'src/pages/Controls/IndexItem'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { ControlListItemConfig } from 'src/pages/Controls/IndexItem/ControlListItem.constants'
import { getControlsListItemTemplateColumns } from 'src/pages/Controls/IndexItem/ControlsListItem.helpers'
import { useCurrentEvidenceGroup } from 'src/pages/Evidence/context/CurrentEvidenceGroupContext'
import { AuditScanProgressProvider } from 'src/pages/Roadmap_v2/smartchecks/context/AuditScanProgressContext'
import {
  LinkEvidenceToControlsModal,
  LinkEvidenceToControlsModalType,
} from 'src/pages/Evidence/modals/LinkEvidenceToControlsModal'
import { ControlsTabNoResults } from './EvidenceControlsBody.components'

export const EvidenceControlsBody = ({
  evidence,
  controls,
  isLoading,
}: {
  evidence: EvidenceGroup
  controls: EvidenceControl[]
  isLoading: boolean
}): JSX.Element => {
  const { data: audit } = useCurrentAudit()
  const { setCurrentEvidenceGroup } = useCurrentEvidenceGroup()
  const canViewAuditScans = useCanPerformAction(CAPABILITY.CAN_VIEW_AUDIT_SCANS)

  useEffect(() => {
    setCurrentEvidenceGroup(evidence)
  }, [evidence, setCurrentEvidenceGroup])

  const evidenceConfig = ControlListItemConfig.EVIDENCE
  const templateColumns = getControlsListItemTemplateColumns(
    false,
    canViewAuditScans,
    evidenceConfig,
  )

  const controlIds = useMemo(() => {
    return controls.map((control) => control.getControlModelId())
  }, [controls])

  return isLoading ? (
    <TableListLoader />
  ) : (
    <AuditScanProgressProvider>
      <>
        {controls.length ? (
          <Grid pb="xs" gridTemplateColumns={templateColumns}>
            <ControlsIndexGridHeader config={evidenceConfig} />
            {controls.map((control) => {
              const id = control.getControlModelId()
              const isViaRequest = control.getIsViaRequest()
              return (
                <ControlsListItem
                  key={id}
                  controlModelId={id}
                  audit={audit}
                  config={
                    isViaRequest
                      ? ControlListItemConfig.EVIDENCE_VIA_REQUEST
                      : evidenceConfig
                  }
                />
              )
            })}
          </Grid>
        ) : (
          <ControlsTabNoResults />
        )}
        <LinkEvidenceToControlsModal
          evidenceId={evidence.getEvidenceId()}
          existingControlIds={controlIds}
          type={LinkEvidenceToControlsModalType.UPDATE}
        />
      </>
    </AuditScanProgressProvider>
  )
}
